export const getLeasesBasicInfoApi = (params, query) => {
    const queryString = new URLSearchParams(query).toString();
    return `/leases${queryString ? `?${queryString}` : ''}`
}



